import React from "react";
import { Info } from "lucide-react";
import UseContext from "hooks/useContext";
import Switch from "components/switch/Switch";
import Tooltip from "components/tooltips/Tooltips";

const SWITCH_ID = "mission-jobbiz-backfill";
const HELP_ID = "mission-jobbiz-backfill-help";

/** "Jobbiz complète si besoin", under the list of every tab. */
const JobbizBackfillSwitch = ({ checked, onChange }) => {
    const { language } = UseContext();
    const label = (key, defaultValue) => language.getValue(`missionCreation.invitation.backfill.${key}`, defaultValue);
    const help = label(
        "help",
        "Si un candidat se désiste ou s'il manque du monde, Jobbiz propose la mission à ses profils, au tarif standard."
    );

    return (
        <div className="flex items-center gap-3">
            <Switch id={SWITCH_ID} size="sm" checked={checked} onChange={onChange} ariaDescribedBy={HELP_ID} />
            <label htmlFor={SWITCH_ID} className="ft-sm font-medium text-gray-900 cursor-pointer">
                {label("label", "Jobbiz complète si besoin")}
            </label>
            <Tooltip text={help} placement="top">
                <button
                    type="button"
                    aria-label={label("moreInfo", "En savoir plus")}
                    aria-describedby={HELP_ID}
                    className="flex h-6 w-6 items-center justify-center rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-300"
                >
                    <Info size={16} color="#6B7280" aria-hidden="true" />
                </button>
            </Tooltip>
            <span id={HELP_ID} className="sr-only">
                {help}
            </span>
        </div>
    );
};

export default JobbizBackfillSwitch;
